<template>
  <div class="container report">
    <div class="searchCondition">
        <el-date-picker
            v-model="serachDate"
            type="month"
            size="mini"
            value-format="yyyy-MM"
            placeholder="select" />
		<el-select v-model="searchKey" style="width: 120px" size="mini">
				<el-option key="offer_id" label="offer id" value="offer_id" />
				<el-option key="package_id" label="package id" value="package_id" />
		</el-select>
      <el-input
        v-model="searchValue"
        style="width: 300px"
        placeholder="Separated by ','"
        clearable
		size="mini"
      ></el-input>
      <el-button size="mini" @click="search">Search</el-button>
      <exportcsv :rows="rows" filename="MmpOffer" :tableObj="$refs.table"></exportcsv>
    </div>
    <el-table
      :data="rows"
      border
      stripe
      class="channel-table"
      v-loading="loading"
      header-row-class-name="table-header"
      row-class-name="channel-table-row"
      element-loading-background="rgba(0, 0, 0, 0.2)"
			ref="table"
    >
        <el-table-column label="Offer Month" prop="offer_month" min-width="150" />
        <el-table-column label="Offer Id" prop="offer_id" min-width="150" />
        <el-table-column label="Offer Name" prop="offer_name" min-width="150" />
        <el-table-column label="Pid" prop="pid" width="120" />
        <el-table-column width="98" label="Price" prop="offer_price"></el-table-column>
        <el-table-column label="Cap" prop="cap_info" min-width="100" />
        <el-table-column label="Event" prop="event_count" min-width="100" />
        <el-table-column label="Cost" prop="cost" min-width="100" />
        <el-table-column label="Actions">
            <el-button slot-scope="sp" type="text" @click.native="edit(sp.row)" >Edit</el-button>
        </el-table-column>
    </el-table>
    <el-pagination
      style="margin-left: 30px"
      layout="total,sizes,prev, pager, next"
      :total="total"
      :current-page.sync="page"
      @current-change="search"
      :page-size.sync="limit"
      @size-change="search"
      :page-sizes="[20,50,100]"

    >
    </el-pagination>
		<el-dialog :visible.sync="showEditEventCount">
			<span slot="title">Edit</span>
			<el-form label-width="200px" class="edit-timezone">
				<el-form-item label="Events" required>
                    <el-input-number v-model="update.event_count" :step="1" step-strictly :min="0" />
				</el-form-item>
				<el-form-item style="text-align:right;">
					<el-button type="primary" @click="onSumbit">Save</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
  </div>
</template>
<script>
import { post } from "@/lib/channelClient";
import exportcsv from '@/components/channelClient/exportcsv.vue';

export default {
	components:{
		exportcsv,
	},
	data() {
		return {
			searchKey: 'offer_id',
			searchValue: '',
            serachDate: '',
			rows: [],
			total: 0,
			limit: 100,
			page: 1,
			loading: false,
			checkedProps:[],
            showEditEventCount: false,
            selectRow: null,
            update: {
                offer_id: null,
                event_count: 0,
                offer_price: 0,
            },
		};
	},
	mounted() {
		this.search();
	},
	methods: {
		async logout() {
			await post("/channelClient/logout", {});
			window.location.href = "/login";
		},
		async search() {
			this.loading = true;
            const where = {};
            if (this.searchValue) {
                where[this.searchKey] = this.searchValue;
            }
            if (this.serachDate) {
                where.offer_month = new Date(this.serachDate);
            }
			const res = await post("/channelClient/mmpOffers", { page: this.page, limit: this.limit, where });
			const body = await res.json();
			this.loading = false;
			this.rows = body.rows;
			this.total = body.count;
		},
        edit(row) {
            this.selectRow = row;
            this.update._id = row._id;
            this.update.event_count = row.event_count || 0;
            this.update.offer_price = row.offer_price;
            this.showEditEventCount = true;
        },
        async onSumbit() {
			const res = await post("/channelClient/updateMmpOffer", this.update);
            this.showEditEventCount = false;
            this.search();
        }
	},
};
</script>
<style scoped>
.props{
	margin-left: 20px;
}
.channel-table-row {
	padding: 10px 0;
}
.channel-table > :nth-child(3) {
	height: calc(100% - 30px);
	overflow-y: scroll;
}

</style>